/** 通用路径前缀 */
const COMMON_PREFIX = '/pages';
/** 分包通用路径前缀 */
const SUBPACK_COMMON_PREFIX = '/pages';
/** 主流程分包路径前缀 */
const MAIN_PREFIX = '/subpack-main';
/** 主要功能分包路径前缀 */
const MAIN_V1_PREFIX = '/subpack-main-v1';
/** 次要功能分包路径前缀 */
const MINOR_PREFIX = '/subpack-minor';
/** 营销活动分包路径前缀 */
const ACTIVITY_PREFIX = '/subpack-activity';

/**
 * 页面路由路径
 */
export const PAGE_PATH = {
  home: { route: `${COMMON_PREFIX}/home/index`, title: '' },
  classify: { route: `${COMMON_PREFIX}/classify/index`, title: '' },
  member: { route: `${COMMON_PREFIX}/member/index`, title: '' },
  cart: { route: `${COMMON_PREFIX}/cart/index`, title: '购物车' },
  self: { route: `${COMMON_PREFIX}/self/index`, title: '我的' },

  activity: {
    route: `${COMMON_PREFIX}${MAIN_PREFIX}${SUBPACK_COMMON_PREFIX}/activity/index`,
    title: '活动',
  },
  commodity: {
    route: `${COMMON_PREFIX}${MAIN_PREFIX}${SUBPACK_COMMON_PREFIX}/commodity/index`,
    title: '商品详情',
  },
  orderList: {
    route: `${COMMON_PREFIX}${MAIN_PREFIX}${SUBPACK_COMMON_PREFIX}/order/list/index`,
    title: '我的订单',
  },
  orderDetail: {
    route: `${COMMON_PREFIX}${MAIN_PREFIX}${SUBPACK_COMMON_PREFIX}/order/detail/index`,
    title: '订单详情',
  },
  orderConfirm: {
    route: `${COMMON_PREFIX}${MAIN_PREFIX}${SUBPACK_COMMON_PREFIX}/order/confirm/index`,
    title: '订单确认',
  },
  orderLogistics: {
    route: `${COMMON_PREFIX}${MAIN_PREFIX}${SUBPACK_COMMON_PREFIX}/order/logistics/detail/index`,
    title: '订单物流',
  },
  afterSaleChoose: {
    route: `${COMMON_PREFIX}${MAIN_PREFIX}${SUBPACK_COMMON_PREFIX}/aftersale/choose/index`,
    title: '选择售后类型',
  },
  afterSaleChooseRefund: {
    route: `${COMMON_PREFIX}${MAIN_PREFIX}${SUBPACK_COMMON_PREFIX}/aftersale/choose/refund/index`,
    title: '选择退款商品',
  },
  afterSaleList: {
    route: `${COMMON_PREFIX}${MAIN_PREFIX}${SUBPACK_COMMON_PREFIX}/aftersale/list/index`,
    title: '退款/售后',
  },
  afterSaleApply: {
    route: `${COMMON_PREFIX}${MAIN_PREFIX}${SUBPACK_COMMON_PREFIX}/aftersale/apply/index`,
    title: '申请售后',
  },
  afterSaleDetail: {
    route: `${COMMON_PREFIX}${MAIN_PREFIX}${SUBPACK_COMMON_PREFIX}/aftersale/detail/index`,
    title: '售后详情',
  },
  afterSaleConsultRecord: {
    route: `${COMMON_PREFIX}${MAIN_PREFIX}${SUBPACK_COMMON_PREFIX}/aftersale/consult-record/index`,
    title: '协商记录',
  },
  afterSaleLogisticsDetail: {
    route: `${COMMON_PREFIX}${MAIN_PREFIX}${SUBPACK_COMMON_PREFIX}/aftersale/logistics/detail/index`,
    title: '退换货物流',
  },
  afterSaleLogisticsInput: {
    route: `${COMMON_PREFIX}${MAIN_PREFIX}${SUBPACK_COMMON_PREFIX}/aftersale/logistics/input/index`,
    title: '填写退换货物流',
  },

  forumList: {
    route: `${COMMON_PREFIX}${MAIN_V1_PREFIX}${SUBPACK_COMMON_PREFIX}/forum/list/index`,
    title: '论坛列表',
  },
  forumTopics: {
    route: `${COMMON_PREFIX}${MAIN_V1_PREFIX}${SUBPACK_COMMON_PREFIX}/forum/topics-square/index`,
    title: '话题广场',
  },
  forumNoteDetail: {
    route: `${COMMON_PREFIX}${MAIN_V1_PREFIX}${SUBPACK_COMMON_PREFIX}/forum/note-detail/index`,
    title: '帖子详情',
  },
  forumTopicDetail: {
    route: `${COMMON_PREFIX}${MAIN_V1_PREFIX}${SUBPACK_COMMON_PREFIX}/forum/topic-detail/index`,
    title: '帖子详情',
  },
  forumRanking: {
    route: `${COMMON_PREFIX}${MAIN_V1_PREFIX}${SUBPACK_COMMON_PREFIX}/forum/ranking/index`,
    title: '比赛排名',
  },
  forumPublish: {
    route: `${COMMON_PREFIX}${MAIN_V1_PREFIX}${SUBPACK_COMMON_PREFIX}/forum/publish/index`,
    title: '发布笔记',
  },
  forumMessage: {
    route: `${COMMON_PREFIX}${MAIN_V1_PREFIX}${SUBPACK_COMMON_PREFIX}/forum/message/index`,
    title: '消息中心',
  },
  forumProfile: {
    route: `${COMMON_PREFIX}${MAIN_V1_PREFIX}${SUBPACK_COMMON_PREFIX}/forum/profile/index`,
    title: '个人中心',
  },
  forumPublishSelect: {
    route: `${COMMON_PREFIX}${MAIN_V1_PREFIX}${SUBPACK_COMMON_PREFIX}/forum/publish/select`,
    title: '发布选择',
  },
  blindBoxCoupon: {
    route: `${COMMON_PREFIX}${MAIN_V1_PREFIX}${SUBPACK_COMMON_PREFIX}/blind-box/coupon/index`,
    title: '盲盒优惠券',
  },
  blindBoxActivity: {
    route: `${COMMON_PREFIX}${MAIN_V1_PREFIX}${SUBPACK_COMMON_PREFIX}/blind-box/activity/index`,
    title: '盲盒活动',
  },
  blindBoxActivityV2: {
    route: `${COMMON_PREFIX}${MAIN_V1_PREFIX}${SUBPACK_COMMON_PREFIX}/blind-box-v2/index/index`,
    title: '盲盒活动',
  },
  blindBoxRecord: {
    route: `${COMMON_PREFIX}${MAIN_V1_PREFIX}${SUBPACK_COMMON_PREFIX}/blind-box/record/index`,
    title: '开盒记录',
  },
  blindBoxRecordV2: {
    route: `${COMMON_PREFIX}${MAIN_V1_PREFIX}${SUBPACK_COMMON_PREFIX}/blind-box-v2/record/index`,
    title: '开盒记录',
  },
  blindBoxDetail: {
    route: `${COMMON_PREFIX}${MAIN_V1_PREFIX}${SUBPACK_COMMON_PREFIX}/blind-box/detail/index`,
    title: '开盒记录详情',
  },
  blindBoxHelp: {
    route: `${COMMON_PREFIX}${MAIN_V1_PREFIX}${SUBPACK_COMMON_PREFIX}/blind-box/help/index`,
    title: '帮好友助力',
  },
  integralCommodity: {
    route: `${COMMON_PREFIX}${MAIN_V1_PREFIX}${SUBPACK_COMMON_PREFIX}/integral/commodity/index`,
    title: '积分商品',
  },
  integralRule: {
    route: `${COMMON_PREFIX}${MAIN_V1_PREFIX}${SUBPACK_COMMON_PREFIX}/integral/rule/index`,
    title: '积分规则',
  },
  integralDetailed: {
    route: `${COMMON_PREFIX}${MAIN_V1_PREFIX}${SUBPACK_COMMON_PREFIX}/integral/detailed/index`,
    title: '积分明细',
  },
  shoppingCreditRule: {
    route: `${COMMON_PREFIX}${MAIN_V1_PREFIX}${SUBPACK_COMMON_PREFIX}/shopping-credit/rule/index`,
    title: '购物金规则',
  },
  shoppingCreditDetailed: {
    route: `${COMMON_PREFIX}${MAIN_V1_PREFIX}${SUBPACK_COMMON_PREFIX}/shopping-credit/detailed/index`,
    title: '购物金明细',
  },
  signIn: {
    route: `${COMMON_PREFIX}${MAIN_V1_PREFIX}${SUBPACK_COMMON_PREFIX}/sign-in/index`,
    title: '签到',
  },
  distributorCenter: {
    route: `${COMMON_PREFIX}${MAIN_V1_PREFIX}${SUBPACK_COMMON_PREFIX}/distributor/center/index`,
    title: '分销员中心',
  },
  distributorKpi: {
    route: `${COMMON_PREFIX}${MAIN_V1_PREFIX}${SUBPACK_COMMON_PREFIX}/distributor/kpi/index`,
    title: '业绩统计',
  },
  distributorOrder: {
    route: `${COMMON_PREFIX}${MAIN_V1_PREFIX}${SUBPACK_COMMON_PREFIX}/distributor/order/index`,
    title: '推广订单',
  },
  distributorPurchaseCustomer: {
    route: `${COMMON_PREFIX}${MAIN_V1_PREFIX}${SUBPACK_COMMON_PREFIX}/distributor/purchase-customer/index`,
    title: '我的购卡用户',
  },
  distributorOrderDetail: {
    route: `${COMMON_PREFIX}${MAIN_V1_PREFIX}${SUBPACK_COMMON_PREFIX}/distributor/order-detail/index`,
    title: '订单详情',
  },
  distributorProduct: {
    route: `${COMMON_PREFIX}${MAIN_V1_PREFIX}${SUBPACK_COMMON_PREFIX}/distributor/product/index`,
    title: '推广商品',
  },
  distributorCustomer: {
    route: `${COMMON_PREFIX}${MAIN_V1_PREFIX}${SUBPACK_COMMON_PREFIX}/distributor/customer/index`,
    title: '我的客户',
  },
  distributorPickup: {
    route: `${COMMON_PREFIX}${MAIN_V1_PREFIX}${SUBPACK_COMMON_PREFIX}/distributor/pickup/index`,
    title: '订单核销',
  },
  distributorCustomerDetail: {
    route: `${COMMON_PREFIX}${MAIN_V1_PREFIX}${SUBPACK_COMMON_PREFIX}/distributor/customer-detail/index`,
    title: '客户详情',
  },
  distributorSearch: {
    route: `${COMMON_PREFIX}${MAIN_V1_PREFIX}${SUBPACK_COMMON_PREFIX}/distributor/search/index`,
    title: '搜索',
  },
  memberDetail: {
    route: `${COMMON_PREFIX}${MAIN_V1_PREFIX}${SUBPACK_COMMON_PREFIX}/member/detail/index`,
    title: '会员详情',
  },
  memberPrivilege: {
    route: `${COMMON_PREFIX}${MAIN_V1_PREFIX}${SUBPACK_COMMON_PREFIX}/member/privilege/index`,
    title: '特权详情',
  },
  memberActivate: {
    route: `${COMMON_PREFIX}${MAIN_V1_PREFIX}${SUBPACK_COMMON_PREFIX}/member/activate/index`,
    title: '会员激活',
  },
  memberPurchaseRecord: {
    route: `${COMMON_PREFIX}${MAIN_V1_PREFIX}${SUBPACK_COMMON_PREFIX}/member/purchase-record/index`,
    title: '购卡记录',
  },
  coupon: {
    route: `${COMMON_PREFIX}${MAIN_V1_PREFIX}${SUBPACK_COMMON_PREFIX}/coupon/index/index`,
    title: '优惠券',
  },
  couponDetail: {
    route: `${COMMON_PREFIX}${MAIN_V1_PREFIX}${SUBPACK_COMMON_PREFIX}/coupon/detail/index`,
    title: '优惠券详情',
  },
  couponInvalid: {
    route: `${COMMON_PREFIX}${MAIN_V1_PREFIX}${SUBPACK_COMMON_PREFIX}/coupon/invalid/index`,
    title: '已使用/已失效券',
  },
  addressList: {
    route: `${COMMON_PREFIX}${MAIN_V1_PREFIX}${SUBPACK_COMMON_PREFIX}/address/list/index`,
    title: '地址列表',
  },
  addressControl: {
    route: `${COMMON_PREFIX}${MAIN_V1_PREFIX}${SUBPACK_COMMON_PREFIX}/address/control/index`,
    title: '地址管理',
  },
  addressModify: {
    route: `${COMMON_PREFIX}${MAIN_V1_PREFIX}${SUBPACK_COMMON_PREFIX}/address/modify/index`,
    title: '地址管理',
  },
  search: {
    route: `${COMMON_PREFIX}${MAIN_V1_PREFIX}${SUBPACK_COMMON_PREFIX}/search/index/index`,
    title: '搜索',
  },
  searchResult: {
    route: `${COMMON_PREFIX}${MAIN_V1_PREFIX}${SUBPACK_COMMON_PREFIX}/search/result/index`,
    title: '搜索结果',
  },
  raffle: {
    route: `${COMMON_PREFIX}${MAIN_V1_PREFIX}${SUBPACK_COMMON_PREFIX}/raffle/index`,
    title: '抽奖',
  },

  login: {
    route: `${COMMON_PREFIX}${MINOR_PREFIX}${SUBPACK_COMMON_PREFIX}/login/index`,
    title: '登录',
  },
  tool: {
    route: `${COMMON_PREFIX}${MINOR_PREFIX}${SUBPACK_COMMON_PREFIX}/tool/index`,
    title: '更多',
  },
  freeShip: {
    route: `${COMMON_PREFIX}${MINOR_PREFIX}${SUBPACK_COMMON_PREFIX}/free-ship/index`,
    title: '运费优惠',
  },
  web: {
    route: `${COMMON_PREFIX}${MINOR_PREFIX}${SUBPACK_COMMON_PREFIX}/web/index`,
    title: 'web',
  },
  richText: {
    route: `${COMMON_PREFIX}${MINOR_PREFIX}${SUBPACK_COMMON_PREFIX}/rich-text/index`,
    title: '富文本',
  },
  userInfo: {
    route: `${COMMON_PREFIX}${MINOR_PREFIX}${SUBPACK_COMMON_PREFIX}/user-info/index`,
    title: '个人信息',
  },
  authUser: {
    route: `${COMMON_PREFIX}${MINOR_PREFIX}${SUBPACK_COMMON_PREFIX}/auth-user/index`,
    title: '授权昵称',
  },

  fulfilPresent: {
    route: `${COMMON_PREFIX}${ACTIVITY_PREFIX}${SUBPACK_COMMON_PREFIX}/fulfil-present/index`,
    title: '优惠活动',
  },
  selectiveGift: {
    route: `${COMMON_PREFIX}${ACTIVITY_PREFIX}${SUBPACK_COMMON_PREFIX}/selective-gift/index`,
    title: '优惠活动',
  },
  halfDiscount: {
    route: `${COMMON_PREFIX}${ACTIVITY_PREFIX}${SUBPACK_COMMON_PREFIX}/half-discount/index`,
    title: '优惠活动',
  },
  purchasePremium: {
    route: `${COMMON_PREFIX}${ACTIVITY_PREFIX}${SUBPACK_COMMON_PREFIX}/purchase-premium/index`,
    title: '优惠活动',
  },
  // 打包一口价
  packageDiscount: {
    route: `${COMMON_PREFIX}${ACTIVITY_PREFIX}${SUBPACK_COMMON_PREFIX}/package-discount/index`,
    title: '优惠活动',
  },
  shoppingCreditsClaim: {
    route: `${COMMON_PREFIX}${ACTIVITY_PREFIX}${SUBPACK_COMMON_PREFIX}/shopping-credits-claim/index`,
    title: '优惠活动',
  },
  shoppingCreditsDeduction: {
    route: `${COMMON_PREFIX}${ACTIVITY_PREFIX}${SUBPACK_COMMON_PREFIX}/shopping-credits-deduction/index`,
    title: '优惠活动',
  },
  couponGiftpack: {
    route: `${COMMON_PREFIX}${ACTIVITY_PREFIX}${SUBPACK_COMMON_PREFIX}/coupon-giftpack/index`,
    title: '优惠活动',
  },
  couponSuit: {
    route: `${COMMON_PREFIX}${ACTIVITY_PREFIX}${SUBPACK_COMMON_PREFIX}/coupon-suit/index`,
    title: '适用商品',
  },
};
